export { default } from './Tab';
export * from './Tab.types';
export { default as tabClasses } from './tabClasses';
export * from './tabClasses';